import React, { Component } from "react";

export class CostReportMonthlySummary extends Component {
   render() {
       const {header,itemList}=this.props;
       return(
        <div className="cost-report-summary-container">
             <h1 className="cost-report-summary-title">{header}</h1>
             <div className="cost-report-summary-list">
                 {itemList.map((item,id)=>
                     <div key={id}>
                        <h1 className="cost-report-list-header">{item.itemName}</h1>
                        <p className="cost-report-list-price">{item.itemPrice}</p>
                    </div>
                 )}                                
             </div>
        </div>
       );
   }
}